import { render, staticRenderFns } from "./ReturnGoods.vue?vue&type=template&id=4cc871be&scoped=true"
import script from "./ReturnGoods.vue?vue&type=script&lang=js"
export * from "./ReturnGoods.vue?vue&type=script&lang=js"
import style0 from "./ReturnGoods.vue?vue&type=style&index=0&id=4cc871be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc871be",
  null
  
)

export default component.exports